import { useEffect, useState } from "react";

import { Descriptions, Divider, Flex, Select, Space } from "antd";
import Title from "antd/lib/typography/Title"
import TextArea from "antd/lib/input/TextArea"

import { BaseButton, ConfirmButton, DataGrid, FillButton } from "components/elements";
import { BaseContainer, SimpleModal } from "components/containers";

import OrderStepContainer from "./OrderStepContainer";
import { getOrderMoniteringBookAPI, getOrderMoniteringMemberAPI, postOrderMoniteringAPI } from "api/order-book";
import { curriculumOptions, watchReasonOptions } from "data/options";
import OrderMoniteringTable from "./OrderMoniteringTable";
import OrderMoniteringCateTable from "./OrderMoniteringCateTable";
import { useParams } from "react-router-dom";

const OrderMoniteringView = () => {
  const { type, no } = useParams()
  const [list, setList] = useState(null)
  const [bookList, setBookList] = useState(null)

  const orderNo = type === 'order' ? no : 0
  const tmpOrderNo = type === 'tmp' ? no : null

  const fnGetList = async () => {
    try {
      const { data } = await getOrderMoniteringMemberAPI(orderNo, tmpOrderNo)
      setList(data)
      for (const member of data?.member_list) {
        await fnGetBookList(member.MEMBER_IDX)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fnGetBookList = async (member_idx) => {
    try {
      const { data } = await getOrderMoniteringBookAPI(orderNo, tmpOrderNo, member_idx)
      const { cate_list, data_list } = data
      const result = {
        cate_list,
        data_list: data_list?.map(it => it.item_list)
      }
      setBookList(prev => ({...prev, [member_idx]: result}))
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fnGetList()
  }, [])

  const columns = [
    { title: '번호', align: 'center', width: '5%',
      render: (text, record, idx) => idx+1
    },
    { title: '회원명', align: 'center', width: '15%',
      render: (_, record) => 
        <Space direction={'vertical'}>
          {`${record?.MEMBER_NAME} (${record?.AGE}세)`}
          {record?.BRANCH_NAME}
          {`${record?.SCHOOL_NAME}(${record?.SCHOOL_LEADER_NAME})`}
          {curriculumOptions?.find(it => it.value === record?.CURRICULUM)?.label}
        </Space>
    },
    { title: <Flex justify={'center'}>내역</Flex>,
      render: (text, record) => 
        <Flex wrap={'wrap'} gap={5}>
          <OrderMoniteringCateTable data={bookList?.[record?.MEMBER_IDX]?.cate_list} />
          {bookList?.[record?.MEMBER_IDX]?.data_list?.map(it => 
            <OrderMoniteringTable
              tmpOrderNo={tmpOrderNo}
              memberIdx={record?.MEMBER_IDX}
              subject={bookList?.[record?.MEMBER_IDX]?.cate_list}
              data={it}         
              isView
            />
          )}
        </Flex>
    }
  ]

  return (
      <BaseContainer>
        <DataGrid
          columns={columns}
          data={list?.member_list}
        />
      </BaseContainer>
  )
}

export default OrderMoniteringView;